import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate, UtilsMisc } from '@pit/core';
import { IDtoShipmentProcess, ShipmentDeliveryType, ShipmentProcessState } from '../interfaces/dto.shipment.process.interface';
import { DtoShipmentProcess } from './dto.shipment.process';
import { IDtoShipmentList } from '../interfaces/dto.shipment.list.interface';

// @dynamic
@JsonObject('DtoShipmentList')
export class DtoShipmentList extends ModelEntity implements IDtoShipmentList {

    constructor(initValues: Partial<IDtoShipmentList> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('depotNumber', String, true)
    public depotNumber?: string = null;

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('deviceIsAssigned', Boolean, true)
    public deviceIsAssigned?: boolean = false;

    @JsonProperty('externalShipmentId', String, true)
    public externalShipmentId?: string = null;

    @JsonProperty('shipmentDate', UtilsJsonConverterDate, true)
    public shipmentDate?: Date = null;

    @JsonProperty('shipmentNumbers', [String], true)
    public shipmentNumbers?: string[] = [];

    @JsonProperty('productTypeCode', String, true)
    public productTypeCode?: string = null;

    @JsonProperty('productTypeDescription', String, true)
    public productTypeDescription?: string = null;

    @JsonProperty('userDescription', String, true)
    public userDescription?: string = null;

    @JsonProperty('userName', String, true)
    public userName?: string = null;

    @JsonProperty('currentProcess', DtoShipmentProcess, true)
    public currentProcess?: IDtoShipmentProcess = null;

    public get isFinished(): boolean {
        return (this.currentProcess.isFinished === true);
    }

    public get isOpen(): boolean {
        return (this.isFinished === false);
    }

    public get processStateDescription(): string {
        return this.currentProcess?.processStateDescription;
    }

    public getHasShipmentNumber(shipmentNumber: string): boolean {
        return ((UtilsMisc.isNullOrUndefined(this.shipmentNumbers) === false) && (this.shipmentNumbers.length > 0) && (this.shipmentNumbers.includes(shipmentNumber)));
    }

}
